module.exports = __webpack_public_path__ + "static/media/googleLogo.c9e995be.png";